<aside>
  <div class="position-lg-sticky top-0">
    <div class="d-none d-lg-block" style="padding-top: 105px;"></div>
    <div class="offcanvas-lg offcanvas-start d-none d-lg-block">
      <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
    </div>
  </div>
</aside>

<ng-template #menuTemplate let-offcanvas>
  <button (click)="offcanvas?.dismiss()" class="btn-close position-absolute top-0 end-0 mt-3 me-3 d-lg-none"
    type="button"></button>
  <div class="offcanvas-body">
    <div class="pb-2 pb-lg-0 mb-4 mb-lg-5"><img class="d-block rounded-circle mb-2 object-fit-cover"
        [src]="userImageUrl" style="width:80px;height:80px;" [alt]="user?.name">
      <h3 class="h5 mb-1">{{user?.name}}</h3>
      <p class="fs-sm text-muted mb-0">{{user?.email}}</p>
    </div>
    <nav class="nav flex-column pb-2 pb-lg-4 mb-3">
      <h4 class="fs-xs fw-medium text-muted text-uppercase pb-1 mb-2">Dashboard</h4>
      <a [routerLink]="['/user/dashboard']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-grid fs-5 opacity-60 me-2"></i>Dashboard</a>
      <a (click)="onCoupon(); offcanvas?.close()" class="nav-link fw-semibold py-2 px-0" role="button"><i
          class="ai-card fs-5 opacity-60 me-2"></i>Aplica un card GiftShare</a>
      <a [routerLink]="['/carduri-cadou']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-gift fs-5 opacity-60 me-2"></i>Comanda carduri cadou</a>
      <a [routerLink]="['/user/comenzi']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-cart fs-5 opacity-60 me-2"></i>Comenzi</a>
      <a [routerLink]="['/user/tranzactii']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-activity fs-5 opacity-60 me-2"></i>Tranzactii & facturi</a>
      <a (click)="onDepositClick(); offcanvas?.close()" class="nav-link fw-semibold py-2 px-0" role="button"><i
          class="ai-wallet fs-5 opacity-60 me-2"></i>Adauga fonduri</a>
      <a [routerLink]="['/user/creare-eveniment']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-calendar-plus fs-5 opacity-60 me-2"></i>Creeaza
        eveniment</a>
      <a [routerLink]="['/user/evenimente']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-calendar fs-5 opacity-60 me-2"></i>Evenimentele mele</a>
    </nav>
    <nav class="nav flex-column pb-2 pb-lg-4 mb-1">
      <h4 class="fs-xs fw-medium text-muted text-uppercase pb-1 mb-2">Cont</h4>
      <a [routerLink]="['/user/profil']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-user-check fs-5 opacity-60 me-2"></i>Profil & facturare</a>
      <a [routerLink]="['/user/securitate']" routerLinkActive="active" (click)="offcanvas?.close()"
        class="nav-link fw-semibold py-2 px-0"><i class="ai-shield fs-5 opacity-60 me-2"></i>Securitate</a>
    </nav>
    <nav class="nav flex-column">
      <a (click)="logout(); offcanvas?.close()" class="nav-link fw-semibold py-2 px-0" role="button">
        <i class="ai-logout fs-5 opacity-60 me-2" role="button"></i>Deconectare</a>
    </nav>
  </div>
</ng-template>
